import { IntegrationInfoResponse } from '@/modules/common/types/dto/response/integration-response';

export interface Client {
  id: string;
  name: string;
  logo?: string;
  email?: string;
  manager?: ClientManager;
  paymentTerms: PaymentTerms;
  billingAddress?: string;
  shippingAddress?: string;
  status?: ClientStatus;
  // Integration fields
  integrations?: ClientIntegration[];
  rawIntegrations?: IntegrationInfoResponse[];
}

export interface ClientManager {
  id: string;
  name: string;
  email: string | null;
  avatar?: string;
  isDeleted: boolean;
}

export enum ClientStatus {
  Active = 'active',
  Archived = 'archived',
}

export enum PaymentTerms {
  Net7 = 'net7',
  Net15 = 'net15',
  Net30 = 'net30',
  Net45 = 'net45',
  Net60 = 'net60',
  Net90 = 'net90',
  EndOfMonth = 'end_of_month',
  CashInAdvance = 'cash_in_advance',
  CashOnDelivery = 'cash_on_delivery',
  CashWithOrder = 'cash_with_order',
}

export interface ClientIntegration {
  id: string;
  type: string;
  icon: string;
  clients?: ExternalClient[] | null;
  selectedValue?: ExternalClient | null;
  /** True when all external clients for this integration are already linked to other clients */
  allClientsLinked?: boolean;
}

export interface ExternalClient {
  id: string;
  name: string;
}
